import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Dialog } from 'material-ui'

import {
  createMessageSetting,
  updateMessageSetting,
} from '../../state/actions/message-settings'

import buildTextEditor from '../Settings/buildTextEditor'
import MessageTemplateEditor from './MessageTemplateEditor'

const Editor = buildTextEditor(MessageTemplateEditor)

class CreateTemplateDialog extends Component {
  static propTypes = {
    closeCreateTemplateModal: PropTypes.func,
    closeCreateTemplateModalInsert: PropTypes.func,
    handleTemplateSelection: PropTypes.func,
    isEmail: PropTypes.bool,
    isTemplateUpdate: PropTypes.bool,
    open: PropTypes.bool.isRequired,
    onRequestClose: PropTypes.func,
    setting: PropTypes.object.isRequired,
    templateSettings: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  }

  saveTemplate = ({ body, subject, templateName }) => {
    const {
      activeLocation,
      isEmail,
      createTemplate,
      closeCreateTemplateModalInsert,
    } = this.props
    const initialSetting = {
      active: !!body,
      body: '',
      message_type: isEmail ? 'email' : 'text',
      message_setting_type: 'template',
    }

    const theTemplateName = this.prepareTemplateName(templateName)

    const changes = {
      body,
      subject,
      always_send: false,
      template_name: theTemplateName,
      offset: 0,
    }
    if (activeLocation) changes.location_id = activeLocation.id

    return createTemplate(initialSetting, changes).then(({ id }) =>
      closeCreateTemplateModalInsert(id),
    )
  }

  updateTemplate = ({ body, subject, templateName, settingId }) => {
    const { updateMsgSetting, closeCreateTemplateModalInsert } = this.props
    const changes = {
      body,
      subject,
      template_name: templateName,
    }
    return updateMsgSetting(settingId, changes).then(() =>
      closeCreateTemplateModalInsert(settingId),
    )
  }

  prepareTemplateName = templateName => {
    let theTemplateName
    if (!templateName) {
      theTemplateName = `Template #${this.props.templateSettings.length + 1}`
    } else {
      theTemplateName = templateName
    }
    return theTemplateName
  }

  render() {
    const {
      closeCreateTemplateModal,
      handleTemplateSelection,
      isEmail,
      isTemplateUpdate,
      open,
      onRequestClose,
      setting,
      templateSettings,
    } = this.props

    const { body, subject } = setting

    const isTemplate = true

    const editorProps = {
      closeCreateTemplateModal,
      handleTemplateSelection,
      isEmail,
      isTemplate,
      isTemplateUpdate,
      saveTemplate: this.saveTemplate,
      setting,
      templateSettings,
      updateTemplate: this.updateTemplate,
    }
    return (
      <Dialog
        open={open}
        onRequestClose={onRequestClose}
        bodyStyle={{ padding: '0' }}
        contentStyle={{ maxWidth: '750px' }}
      >
        {isEmail ? (
          <Editor {...editorProps} body={body} subject={subject} />
        ) : (
          <Editor {...editorProps} body={body} />
        )}
      </Dialog>
    )
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      createTemplate: (initialSetting, changes) =>
        createMessageSetting(initialSetting, changes),
      updateMsgSetting: (id, changes) => updateMessageSetting(id, changes),
    },
    dispatch,
  )

export default connect(null, mapDispatchToProps)(CreateTemplateDialog)



// WEBPACK FOOTER //
// ./src/components/Messages/CreateTemplateDialog.js